import IDisplayErrorInPanelAction from "chrome/panel/duck/actions/interfaces/IDisplayErrorInPanelAction";
import IError from "common/types/IError";
import PanelActionType from "chrome/panel/duck/actionTypes/panelActionType";

export default function displayErrorInPanel(payload: IError): IDisplayErrorInPanelAction {
    return {
        type: PanelActionType.DISPLAY_ERROR_IN_PANEL,
        payload,
    };
}